/* ---------------------------------
-----  dimension variables --------
---------------------------------- */
/* ------  standard elements padding & margin  ------- */
/* spacing */
/**
**  Official Font sizes
------------------------------- */
/**
** Line-heights
------------------------------- */
/*
  Mixin to progressively-enhance :focus-visible, keeping :focus where not supported
  Add an arbitrary list of selectors into the arguments, and the styling in the block.
  I you pass no selectors to the mixin the parent ("ampersand") operator is used instead.

  There are two mixins:
  - focus-visible: a generic focus-visible, giving you "slots" to decide what to render for :focus, :focus reset, and :focus-visible
  - focus-visible-outline: a focus-visible, which only resets the outline. If you don't need more custom resets, use this one!

  Use focus-visible:
  The key thing here is checking which slot is being rendered.
  For example, you can reset box-shadow here, or anything else.

  @include focus-visible using ($slot) {
      @if $slot == focus {
          outline: 2px solid transparent;
          box-shadow: 0 0 0 4px blue;
      }
      @if $slot == focusReset {
          box-shadow: none;
      }
      @if $slot == focusVisible {
          box-shadow: 0 0 0 4px blue;
      }
  }

  Use focus-visible-outline:
  @include focus-visible-outline("button", "a[href]") {
      outline: 2px solid blue;
  }

  Resulting CSS (compressed):

  button:focus,
  a[href]:focus {
      outline: 2px solid blue;
  }

  button:focus:not(:focus-visible),
  a[href]:focus:not(:focus-visible) {
      outline: none;
  }
  button:focus-visible,
  a[href]:focus-visible {
      outline: 2px solid blue;
  }
*/
.ux-slider-pagination {
  position: absolute;
  text-align: center;
  transform: translate3d(0, 0, 0);
  transition: 300ms opacity;
  z-index: 10;
}

.ux-slider-pagination.swiper-pagination-hidden {
  opacity: 0;
}

/* Common Styles */
.swiper-pagination-fraction,
.swiper-pagination-custom,
.ux-slider-container-horizontal > .swiper-pagination-bullets {
  bottom: 10px;
  left: 0;
  width: 100%;
}

/* Bullets */
.swiper-pagination-bullets-dynamic {
  font-size: 0;
  overflow: hidden;
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  position: relative;
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main {
  transform: scale(1);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev {
  transform: scale(0.33);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next {
  transform: scale(0.66);
}

.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next {
  transform: scale(0.33);
}

.ux-slider-pagination .swiper-pagination-bullet {
  background: #000;
  border-radius: 50%;
  display: inline-block;
  height: 8px;
  opacity: 0.2;
  vertical-align: middle;
  width: 8px;
}

.ux-slider-pagination .swiper-pagination-bullet {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 0;
  box-shadow: none;
  margin: 0;
  padding: 0;
}

.ux-slider-pagination.swiper-pagination-clickable .swiper-pagination-bullet {
  cursor: pointer;
}

.ux-slider-pagination .swiper-pagination-bullet-active {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  opacity: 1;
}

.ux-slider-container-vertical > .ux-slider-pagination.swiper-pagination-bullets {
  right: 10px;
  top: 50%;
  transform: translate3d(0, -50%, 0);
}

.ux-slider-container-vertical > .swiper-pagination-bullets .swiper-pagination-bullet {
  display: block;
  margin: 6px 0;
}

.ux-slider-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
}

.ux-slider-container-vertical > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  display: inline-block;
  transition: 200ms transform, 200ms top;
}

.ux-slider-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet {
  margin: 0 4px;
}

.ux-slider-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic {
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}

.ux-slider-container-horizontal > .swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms left;
}

.ux-slider-container-horizontal.ux-slider-container-rtl > .swiper-pagination-bullets-dynamic .swiper-pagination-bullet {
  transition: 200ms transform, 200ms right;
}

.ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled {
  margin: 0 !important;
  background: #fff;
  border-radius: 0;
  border-right: 1px solid #e7e7e7;
  opacity: 1;
  height: 10px;
  width: 100%;
  transform: none !important;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 1024px) {
  .ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled {
    height: 70px;
  }
}
.ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled.swiper-pagination-bullet-active {
  background: #fff;
}
.ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled .ux-slider-pagination-label {
  display: none;
}
@media (min-width: 1024px) {
  .ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled .ux-slider-pagination-label {
    display: block;
  }
}
.ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled .swiper-pagination-progressbar {
  height: 10px;
}
@media (min-width: 1024px) {
  .ux-slider-pagination .ux-slider-pagination__container--label .swiper-pagination-bullet--labeled .swiper-pagination-progressbar {
    height: 5px;
  }
}

/* Progress */
.swiper-pagination-progressbar {
  background: #bbd03a;
  height: 5px;
  left: 0;
  top: 0;
  position: absolute;
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background: var(--swiper-pagination-color, var(--swiper-theme-color));
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  transform: scale(0);
  transform-origin: left top;
  width: 100%;
}

.ux-slider-container-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  transform-origin: right top;
}

.ux-slider-container-horizontal > .swiper-pagination-progressbar,
.ux-slider-container-vertical > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  height: 4px;
  left: 0;
  top: 0;
  width: 100%;
}

.ux-slider-container-vertical > .swiper-pagination-progressbar,
.ux-slider-container-horizontal > .swiper-pagination-progressbar.swiper-pagination-progressbar-opposite {
  height: 100%;
  left: 0;
  top: 0;
  width: 4px;
}

.swiper-pagination-white {
  --swiper-pagination-color: #fff;
}

.swiper-pagination-black {
  --swiper-pagination-color: #000;
}

.swiper-pagination-lock {
  display: none;
}

.ux-slider .ux-slider-pagination {
  align-items: center;
  display: flex;
  height: auto;
  width: auto;
  z-index: 10;
}
.ux-slider .ux-slider-pagination__container {
  position: relative;
}
.ux-slider .ux-slider-pagination__container--dynamic {
  height: 25px;
  overflow: hidden;
  width: 146px;
}
.ux-slider .ux-slider-pagination__container--label {
  display: flex;
  width: 100%;
  border-left: 1px solid #e7e7e7;
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
}
@media (min-width: 1024px) {
  .ux-slider .ux-slider-pagination__container--label {
    border-top: none;
    border-bottom: none;
  }
}
.ux-slider .ux-slider-pagination__navigation-arrow {
  cursor: pointer;
  height: auto;
  padding-left: 5px;
}
.ux-slider .ux-slider-pagination__navigation-arrow--prev {
  padding-left: 5px;
  transform: rotate(180deg);
}
.ux-slider .ux-slider-pagination .swiper-pagination-bullet {
  border-radius: 0;
  cursor: pointer;
  margin: 0 4px;
}
.ux-slider .ux-slider-pagination .swiper-pagination-bullet-active {
  background: #bbd03a;
  cursor: default;
  transform: scale(1.5);
  vertical-align: middle;
}
.ux-slider .ux-slider-pagination .swiper-pagination-bullet:focus {
  outline: none;
}
.ux-slider .ux-slider-pagination--bottom {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  position: relative;
  width: 100%;
}
.ux-slider .ux-slider-pagination--anchor {
  position: absolute;
  transform: translateX(-50%);
}
.ux-slider .ux-slider-pagination--label {
  padding-top: 0;
}
.ux-slider .ux-slider-pagination .swiper-pagination-bullet {
  transition: all 0.35s !important;
}

.ux-slider .ux-slider-pagination .ux-slider-pagination__bullet {
  will-change: width margin translate;
}
.ux-slider .ux-slider-pagination .ux-slider-pagination__bullet--invisible {
  backface-visibility: hidden;
  background: transparent;
  height: 0;
  margin: 0;
  padding: 0;
  width: 0;
}
.ux-slider .ux-slider-pagination .ux-slider-pagination__bullet--small {
  backface-visibility: hidden;
  transform: scale(0.85);
  transform-origin: center;
}
.ux-slider .ux-slider-pagination .ux-slider-pagination__bullet--extra-small {
  backface-visibility: hidden;
  height: 4px;
  transform-origin: center;
  width: 4px;
}

.ux-slider-inline-pagination-anchor {
  display: block;
  height: 25px;
  margin-bottom: 5px;
  margin-top: 25px;
  width: 100%;
}